module.exports = __webpack_public_path__ + "img/green_010.c025bffa.png";